import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=4136d732&scoped=true"
import script from "./PageContainer.vue?vue&type=script&lang=ts"
export * from "./PageContainer.vue?vue&type=script&lang=ts"
import style0 from "./PageContainer.vue?vue&type=style&index=0&id=4136d732&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4136d732",
  null
  
)

export default component.exports